import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { config } from 'src/app/config';
import Util from 'src/app/_helpers/util';
import { LightGallery } from 'lightgallery/lightgallery';
import { OthersService } from 'src/app/_services/others.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PopupcartComponent } from '../../popupcart/popupcart.component';
import { TranslateService } from '@ngx-translate/core';
import { Popupmodal } from 'src/app/_helpers/popupmodal';
import CheckErrortype from 'src/app/_helpers/check-errortype';
import { PopupmessagingComponent } from '../../popupmessaging/popupmessaging.component';
import { formatNumber } from '@angular/common';


@Component({
  selector: 'app-card-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class CardProductDetailComponent implements OnInit {

  @Input() data?: any;  
  @Input() shareData?: any; 
  @Input() shareTitle?: string=''; 
  @Input() shareUrl?: string=''; 
  @Input() productData?: any;  
  @Input() isPublic?: string='N'; 
  @Input() companyData?:any
  @Input() vendorId?: string='';
  @Input() isPreviewShopFront?: string='N';
  @Input() compareData?: any;

  isLogin:boolean=false

  //model
  Valname:string=''
  Valbrand:string=''
  Valdescription:string=''
  Valsku:string=''
  ValmanufacturerSku:string=''
  Valprice:string=''
  ValimageFileName:string=''
  ValisDisplayPriceOnShopfront:boolean=true
  ValisDisplayProductOnShopfront:boolean=false
  Valtags:any=''
  ValquotationInitialPriceOffer:string=''
  ValautobidMinimumPrice:string=''
  ValautobidPriceDecrement:string=''
  ValisAutobidEnabled:boolean=false
  ValisActivatedByUser:boolean=false

  Valstate:string=''

  ValprimaryImg:string=''
  FilenamePirmaryImg:string=''
  ValimageMore:any=[]

  EditProductId:any
  PassData:any
  valspecValueErr: boolean=false;
  valspecLabelErr:boolean=false;
  divFhSpec :any=[] 

  Valdescriptiondraft:string=''
  divFhSpecdraft :any=[] 
  
  existingProductid: any
  existingProductname: any
  existingProductbrand: any
  existingProductdescription: any
  existingProductsku: any
  existingProductmanufacturerSku: any
  existingProductCurrency: any
  existingProductprice: any
  existingProductimageUrl: any
  existingProducttags: any
  existingProductisDisplayPriceOnShopfront: any
  existingProductisDisplayProductOnShopfront: any
  existingProductquotationInitialPriceOffer: any
  existingProductautobidMinimumPrice: any
  existingProductautobidPriceDecrement: any
  existingProductisAutobidEnabled: any
  existingProductstate: any  
  existingProductpublishApprovalStatus: any
  existingProductpublishedOngoingApprovalStatus: any
  existingProductisActivatedByUser: any
  existingProductcreatedDate: any
  existingProductcreatedBy: any
  existingProductmodifiedDate: any
  existingProductmodifiedBy: any


  draftProductid: any
  draftProductdraftName: any
  draftProductdraftBrand: any
  draftProductdraftDescription: any
  draftProductdraftSku: any
  draftProductdraftManufacturerSku: any
  draftProductdraftCurrency: any
  draftProductdraftPrice: any
  draftProductdraftImageUrl: any
  draftProductdraftTags: any
  draftProductdraftIsDisplayPriceOnShopfront: any
  draftProductdraftIsDisplayProductOnShopfront: any
  draftProductdraftQuotationInitialPriceOffer: any
  draftProductdraftAutobidMinimumPrice: any
  draftProductdraftAutobidPriceDecrement: any
  draftProductdraftIsAutobidEnabled: any
  draftProductdraftCreatedDate: any
  draftProductdraftCreatedBy: any
  draftProductdraftModifiedDate: any
  draftProductdraftModifiedBy: any
  
  SelectedTagsExist:any=[]
  SelectedTagsDraft:any=[]
  
  isTagsChanges: boolean = false;
  isDescChanges: boolean = false;
  isDescSpecChanges : boolean = false;

  desc1exist:string=''
  desc2exist:any=[]
  desc1draft:string=''
  desc2draft:any=[]

  valcurrency:string='' 
  exsistingCurrency:string=''
  draftCurrency:string=''




  @Input() images?: any;
  @Input() title?: string='';
  @Input() company?: string='';
  @Input() currency?: string='';
  @Input() price?: string='';
  @Input() location?: string='';
  @Input() isConfidential?: string='N';
  @Input() url?: string='';
  @Input() isHome?: string='';

  @Input() isNewCedaUi?: string='';


  galleryId = (Math.random() + 1).toString(36).substring(7)

  private lightGallery!: LightGallery;
  private needRefresh = false;




  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,    
    private othersService: OthersService,
    private popupmodal : Popupmodal,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    console.log("productData : ",this.productData)
    this.itemsGallery = this.productData?.imageUrl ?? []


    console.log("card companyData : ",this.companyData)

    // if(this.isPublic=='Y'){
      if (localStorage.getItem("COMPANYSELECTID") !== null) {
        this.isLogin = true
      } 
    // }

      console.log('compareData : ',this.compareData)

      if(this.compareData){
        this.itemsGallery = this.compareData?.draftProduct.draftImageUrl ?? []


        this.valcurrency= this.compareData.existingProduct.currency
        this.exsistingCurrency = this.compareData.existingProduct.currency
        this.draftCurrency = this.compareData.draftProduct.draftCurrency


      //seperate value
            this.existingProductid=this.compareData.existingProduct.id
            this.existingProductname=this.compareData.existingProduct.name
            this.existingProductbrand=this.compareData.existingProduct.brand
            this.existingProductdescription=this.compareData.existingProduct.description
            this.existingProductsku=this.compareData.existingProduct.sku
            this.existingProductmanufacturerSku=this.compareData.existingProduct.manufacturerSku
            this.existingProductCurrency = this.compareData.existingProduct.currency
            this.existingProductprice= (this.compareData.existingProduct.price) ? this.transformDecimal(this.compareData.existingProduct.price):null
            this.existingProductimageUrl=this.compareData.existingProduct.imageUrl
            this.existingProducttags=this.compareData.existingProduct.tags
            this.existingProductisDisplayPriceOnShopfront=this.compareData.existingProduct.isDisplayPriceOnShopfront
            this.existingProductisDisplayProductOnShopfront=this.compareData.existingProduct.isDisplayProductOnShopfront
            this.existingProductquotationInitialPriceOffer=this.compareData.existingProduct.quotationInitialPriceOffer
            this.existingProductautobidMinimumPrice= (this.compareData.existingProduct.autobidMinimumPrice) ? this.transformDecimal(this.compareData.existingProduct.autobidMinimumPrice):null
            this.existingProductautobidPriceDecrement=(this.compareData.existingProduct.autobidPriceDecrement)? this.transformDecimal(this.compareData.existingProduct.autobidPriceDecrement): null
            this.existingProductisAutobidEnabled=this.compareData.existingProduct.isAutobidEnabled
            this.existingProductstate=this.compareData.existingProduct.state  
            this.existingProductpublishApprovalStatus=this.compareData.existingProduct.publishApprovalStatus
            this.existingProductpublishedOngoingApprovalStatus=this.compareData.existingProduct.publishedOngoingApprovalStatus
            this.existingProductisActivatedByUser=this.compareData.existingProduct.isActivatedByUser
            this.existingProductcreatedDate=this.compareData.existingProduct.createdDate
            this.existingProductcreatedBy=this.compareData.existingProduct.createdBy
            this.existingProductmodifiedDate=this.compareData.existingProduct.modifiedDate
            this.existingProductmodifiedBy=this.compareData.existingProduct.modifiedBy

            this.compareData.existingProduct.tags.forEach((obj: any, key: any) => {
              this.SelectedTagsExist.push(obj.tag)
            });


            this.draftProductid = this.compareData.draftProduct?.id
            this.draftProductdraftName = this.compareData.draftProduct?.draftName
            this.draftProductdraftBrand = this.compareData.draftProduct?.draftBrand
            this.draftProductdraftDescription = this.compareData.draftProduct?.draftDescription
            this.draftProductdraftSku = this.compareData.draftProduct?.draftSku
            this.draftProductdraftManufacturerSku = this.compareData.draftProduct?.draftManufacturerSku
            this.draftProductdraftCurrency = this.compareData.draftProduct?.draftCurrency
            this.draftProductdraftPrice = (this.compareData.draftProduct?.draftPrice) ? this.transformDecimal(this.compareData.draftProduct?.draftPrice):null
            this.draftProductdraftImageUrl = this.compareData.draftProduct?.draftImageUrl
            this.draftProductdraftTags = this.compareData.draftProduct?.draftTags
            this.draftProductdraftIsDisplayPriceOnShopfront = this.compareData.draftProduct?.draftIsDisplayPriceOnShopfront
            this.draftProductdraftIsDisplayProductOnShopfront = this.compareData.draftProduct?.draftIsDisplayProductOnShopfront
            this.draftProductdraftQuotationInitialPriceOffer = this.compareData.draftProduct?.draftQuotationInitialPriceOffer
            this.draftProductdraftAutobidMinimumPrice = (this.compareData.draftProduct?.draftAutobidMinimumPrice) ? this.transformDecimal(this.compareData.draftProduct?.draftAutobidMinimumPrice):null
            this.draftProductdraftAutobidPriceDecrement = (this.compareData.draftProduct?.draftAutobidPriceDecrement) ? this.transformDecimal(this.compareData.draftProduct?.draftAutobidPriceDecrement) : null
            this.draftProductdraftIsAutobidEnabled = this.compareData.draftProduct?.draftIsAutobidEnabled
            this.draftProductdraftCreatedDate = this.compareData.draftProduct?.draftCreatedDate
            this.draftProductdraftCreatedBy = this.compareData.draftProduct?.draftCreatedBy
            this.draftProductdraftModifiedDate = this.compareData.draftProduct?.draftModifiedDate
            this.draftProductdraftModifiedBy = this.compareData.draftProduct?.draftModifiedBy
      
            this.compareData.draftProduct?.draftTags.forEach((obj: any, key: any) => {
              this.SelectedTagsDraft.push(obj.tag)
            });


            var JsontagExist = JSON.stringify(this.SelectedTagsExist) 
            var JsontagDraft = JSON.stringify(this.SelectedTagsDraft) 
            if(JsontagExist !== JsontagDraft){
              this.isTagsChanges = true
            }

          // seperate desc
          this.Valdescription = this.compareData.existingProduct.description

          this.divFhSpec = []
          this.Valdescription = ''
          var desctext = this.compareData.existingProduct.description

          var a = this.compareData.existingProduct.description;
          var getdetaildesc = /<fhspecdiv>(.*?)<\/fhspecdiv>/g.exec(a);

          if(getdetaildesc){
            console.log('>>>>>>>',getdetaildesc[0]);
            console.log('>>>>>>>',getdetaildesc[1]);

            this.divFhSpec = getdetaildesc[1]
            this.divFhSpec = JSON.parse(this.divFhSpec)
            this.Valdescription = desctext.split(getdetaildesc[0]).pop()
            this.Valdescription = desctext.replace(getdetaildesc[0],'')

            // this.divFhSpec.forEach((obj: any, key: any)  => {
            //   this.emptyLabelSpec.push({error:false})
            //   this.emptyValueSpec.push({error:false})
            // });


            console.log('>>>>>>>',desctext);
          }
          else {
            this.Valdescription = this.compareData.existingProduct.description
          }



          this.desc1draft=this.divshotdesc(this.compareData.draftProduct?.draftDescription)
          this.desc2draft=this.divspec2arr(this.compareData.draftProduct?.draftDescription)
          this.desc1exist=this.divshotdesc(this.compareData.existingProduct?.description)
          this.desc2exist=this.divspec2arr(this.compareData.existingProduct?.description)

          console.log('desc2draft : ',this.desc2draft);
          console.log('desc2exist : ',this.desc2exist);
          // seperate desc draft
          this.Valdescriptiondraft = this.compareData.draftProduct?.draftDescription

          this.divFhSpecdraft = []
          //this.Valdescriptiondraft = ''
          var desctextdraft = this.compareData.draftProduct?.draftDescription
          
          var b = this.compareData.draftProduct?.draftDescription
          var getdetaildescdraft = /<fhspecdiv>(.*?)<\/fhspecdiv>/g.exec(b);
          console.log('000 getdetaildescdraft 00 ',getdetaildescdraft);
          if(getdetaildescdraft){
            console.log('>>>>>>>',getdetaildescdraft[0]);
            console.log('>>>>>>>',getdetaildescdraft[1]);

            this.divFhSpecdraft = getdetaildescdraft[1]
            this.divFhSpecdraft = JSON.parse(this.divFhSpecdraft)
            this.Valdescriptiondraft = desctextdraft.split(getdetaildescdraft[0]).pop()

            console.log('>>>>>>> divFhSpecdraft',this.divFhSpecdraft);
            console.log('>>>>>>> Valdescriptiondraft',this.Valdescriptiondraft);
          }
          else {
            this.Valdescriptiondraft = this.compareData.draftProduct?.draftDescription
          }

          var getdetaildesc = /<fhspecdiv>(.*?)<\/fhspecdiv>/g.exec(this.Valdescription);
          console.log('getdetaildesc >> ',getdetaildesc);
          console.log('Valdescription >> ',this.Valdescription);
          console.log('Valdescriptiondraft >> ',this.Valdescriptiondraft);
          if(this.Valdescriptiondraft){
            if(getdetaildesc){
              var JsondescExist = JSON.stringify(getdetaildesc) 
              var JsondescDraft = JSON.stringify(this.Valdescriptiondraft) 
              console.log('JsondescExist',JsondescExist);
              console.log('JsondescDraft',JsondescDraft);
              if(JsondescExist !== JsondescDraft){
                this.isDescChanges = true
              }
            } else {
              var JsondescExist = JSON.stringify(this.compareData.existingProduct.description) 
              var JsondescDraft = JSON.stringify(this.compareData.draftProduct?.draftDescription) 
              console.log('JsondescExist 1',JsondescExist);
              console.log('JsondescDraft 1',JsondescDraft);
              if(JsondescExist !== JsondescDraft){
                this.isDescChanges = true
              }
            }
          }



      }

  }

  

  settingsGallery = {
    counter: true,
    download:false,
    selector: '.itemz'
  };
  
  itemsGallery:any = []

  onInitGallery = (detail:any): void => {
    this.lightGallery = detail.instance;
  };

  ngAfterViewChecked(): void {
    if (this.needRefresh) {
      this.lightGallery.refresh();
      this.needRefresh = false;
    }
  }

  divspec(val:any){
    return Util.fhspectocomma(val)
  }
  divshotdesc(val:any){
    return Util.formatShortDesc(val)
  }  


  addToCart(){
    var productId = this.productData?.id

    this.othersService.postaddProductToCart(productId).subscribe((res:any) => {
      console.log(res)
      if(res.data?.addProductToCart){

        const modalRef = this.modalService.open(PopupcartComponent, {
          modalDialogClass: 'modal-dialog-centered div-modal-content',
          centered: true,
          size: 'md'
        })
        // modalRef.componentInstance.modalconfirm = 'modal'
        // modalRef.componentInstance.title = 'Confirm Bulk Delete'
        // modalRef.componentInstance.subtitle = 'Are you sure want to bulk delete?'
        // modalRef.componentInstance.yesStr = 'Confirm'
        // modalRef.componentInstance.noStr = 'Cancel'
    
        modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          if (res) {  
            this.router.navigate(['/cart']);  
          }
        })



      }
      else if(res.errors){
        var error = res.errors[0].message
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });


          if(res.errors[0].extensions.type=='ProductAlreadyInCart'){

            const modalRef = this.modalService.open(PopupcartComponent, {
              modalDialogClass: 'modal-dialog-centered div-modal-content',
              centered: true,
              size: 'md'
            })

            modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
              if (res) {   
                this.router.navigate(['/cart']);  
              }
            })            
            
            return
          }

          
          if(res.errors[0].extensions.type=='CanNotAddOwnProductToCart'){
            this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
        
            
            return
          }


          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,'/').subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      }
    });

  }
  sendMessage(){


    if(!this.isLogin){
      // var errortext = "Please login first"
      // this.popupmodal.showError(errortext,'/login').subscribe((res:any) => {})

      this.router.navigate(['/login']);  
      return

    }


    // alert('send message from product..')
    const modalRef = this.modalService.open(PopupmessagingComponent, {
      modalDialogClass: '',
      centered: true,
      backdrop : 'static',
      keyboard : false,
      size: 'md'
    })


    modalRef.componentInstance.title = 'Ask Vendor'
    modalRef.componentInstance.sendMessageAs = 'LEADS'
    modalRef.componentInstance.rfqid = this.vendorId
    modalRef.componentInstance.quotationId = null
    
  }

  redirect(){
    console.log("this.companyData?.companyDomain : ",this.companyData?.companyDomain)
    if(this.companyData?.companyDomain){
      this.router.navigate(['/vendor-detail/'+this.companyData?.companyDomain]);
    } 

  }

  comparepage(newElem:any,oldElem:any){
    if(newElem===null){
      newElem=''
    } 
    if(oldElem===null){
      oldElem=''
    }
    var text = ''
    if((oldElem) && (newElem)){
      var oldText = oldElem.toString(),newElem = newElem.toString();
      if(newElem && oldElem && (oldElem !==newElem)){
        newElem.split('').forEach(function(val:any, i:any){
          if (val != oldText.charAt(i))
            text += "<span class='block-yellow'>"+val+"</span>";  
          else
            text += val;            
        });
      } else {
        text = oldElem
      }
    } else {
      text =  "<span class='block-yellow'>"+newElem+"</span>";  
    }

    if(!newElem){
      text = oldElem
    }

    if(text==""||!text){
      text = "-"
    }
    return text
  }


  comparepagespec(textexist:any,textdraft:any){
    var combineres = ''
    combineres +='<ul>';
    //if spec draft more than exist
    if(textexist.length>textdraft.length){
      if(textexist){
        textexist.forEach((obj: any, key: any) => {
          if(textdraft){
            if(textdraft[key]){
              combineres += '<li>'
              combineres += this.comparepage(textdraft[key].label,textexist[key].label)
              combineres += ' : '
              combineres += this.comparepage(textdraft[key].value,textexist[key].value)
              combineres += '</li>'
            } else {
              combineres += '<li>'
              combineres += this.comparepage('',textexist[key].label)
              combineres += ' : '
              combineres += this.comparepage('',textexist[key].value)
              combineres += '</li>'
            }
          }
        });
      }
    }
    //if spec exist more than draft
    else{
      if(textdraft){
        textdraft.forEach((obj: any, key: any) => {

          if(textexist){
            if(textexist[key]){
              combineres += '<li>'
              combineres += this.comparepage(textdraft[key].label,textexist[key].label)
              combineres += ' : '
              combineres += this.comparepage(textdraft[key].value,textexist[key].value)
              combineres += '</li>'
            } else {
              combineres += '<li>'
              combineres += this.comparepage(textdraft[key].label,'')
              combineres += ' : '
              combineres += this.comparepage(textdraft[key].value,'')
              combineres += '</li>'
            }
          }
        });
      }
    }


    combineres +='</ul>';
    if(combineres=='<ul></ul>'){
        return '-'
    } else {
        return combineres
    }
    

  }

  transformDecimal(num:any) {
    return formatNumber(Number(num), 'en-US', '1.0-0')
  }

  divspec2arr(val:any){
    return Util.fhspectoarray(val)
  }  
}
